import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
const firebaseConfig = {
  apiKey: "AIzaSyD26StaUK-1sjrON-KSmXld0NbwY4qvxBY",
  authDomain: "postflow-ai-e75b5.firebaseapp.com",
  projectId: "postflow-ai-e75b5",
  storageBucket: "postflow-ai-e75b5.firebasestorage.app",
  messagingSenderId: "909282361069",
  appId: "1:909282361069:web:856f55213dec2d529116e4",
};

const FUNCTIONS_BASE = "https://us-central1-postflow-ai-e75b5.cloudfunctions.net";

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);


const PLATFORMS = [
  { id: "instagram", label: "Instagram", icon: "📸" },
  { id: "linkedin",  label: "LinkedIn",  icon: "💼" },
  { id: "facebook",  label: "Facebook",  icon: "📘" },
  { id: "tiktok",    label: "TikTok",    icon: "🎵" },
];

const TONES = ["Professional", "Casual", "Funny", "Inspiring", "Authoritative"];

const LANGS = [
  { code: "en", label: "🇬🇧 English" },
  { code: "fi", label: "🇫🇮 Finnish" },
  { code: "sv", label: "🇸🇪 Swedish" },
];

const FREE_LIMIT = 1;

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --bg: #0a0a0f; --surface: #12121a; --border: #1e1e2e;
    --accent: #00f5a0; --accent2: #00d9f5;
    --text: #e8e8f0; --muted: #b0b0cc; --muted2: #b8bdd4; --danger: #ff4d6d;
  }
  body { background: var(--bg); color: var(--text); font-family: 'DM Sans', sans-serif; min-height: 100vh; }
  .app {
    min-height: 100vh; background: var(--bg); padding: 2rem;
    max-width: 1200px; margin: 0 auto;
    background-image:
      radial-gradient(ellipse 60% 50% at 10% 0%, rgba(0,245,160,0.06) 0%, transparent 60%),
      radial-gradient(ellipse 50% 40% at 90% 100%, rgba(0,217,245,0.05) 0%, transparent 60%);
  }
  header { display: flex; align-items: center; gap: 1rem; flex-wrap: wrap; margin-bottom: 3rem; padding-bottom: 1.5rem; border-bottom: 1px solid var(--border); }
  .logo { font-family: 'Bebas Neue', sans-serif; font-size: 1.8rem; font-weight: 800; background: linear-gradient(90deg, var(--accent), var(--accent2)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; letter-spacing: -0.02em; }
  .tagline { font-size: 0.85rem; color: #c0c0dd; font-weight: 400; letter-spacing: 0.05em; text-transform: uppercase; }
  .header-right { margin-left: auto; display: flex; align-items: center; gap: 0.75rem; flex-wrap: wrap; }
  .price-label { font-size: 0.75rem; color: var(--muted); white-space: nowrap; }
  .price-badge { background: rgba(0,245,160,0.12); border: 1px solid rgba(0,245,160,0.3); color: var(--accent); border-radius: 999px; padding: 0.3rem 0.9rem; font-size: 0.85rem; font-family: 'DM Sans', sans-serif; font-weight: 600; white-space: nowrap; }
  .sign-in-btn { padding: 0.38rem 1rem; border-radius: 8px; border: 1px solid var(--border); background: transparent; color: var(--muted); font-size: 0.8rem; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: all 0.15s; }
  .sign-in-btn:hover { border-color: var(--accent); color: var(--accent); }
  .user-chip { display: flex; align-items: center; gap: 0.5rem; background: rgba(0,245,160,0.08); border: 1px solid rgba(0,245,160,0.2); border-radius: 999px; padding: 0.3rem 0.9rem 0.3rem 0.5rem; font-size: 0.8rem; color: var(--accent); }
  .user-avatar { width: 22px; height: 22px; background: linear-gradient(135deg, var(--accent), var(--accent2)); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.65rem; font-weight: 700; color: #0a0a0f; }
  .sign-out-btn { padding: 0.38rem 0.8rem; border-radius: 8px; border: 1px solid transparent; background: transparent; color: var(--muted); font-size: 0.78rem; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: color 0.15s; }
  .sign-out-btn:hover { color: var(--danger); }
  .layout { display: grid; grid-template-columns: 380px 1fr; gap: 2rem; align-items: start; }
  @media (max-width: 768px) { .layout { grid-template-columns: 1fr; } .app { padding: 1rem; } .hero-title { font-size: 1.5rem; } .hero { padding: 0.5rem 0 2rem; } }
  .hero { text-align: center; padding: 1rem 0 3rem; max-width: 700px; margin: 0 auto; }
  .hero-title { font-family: 'Bebas Neue', sans-serif; font-size: 2rem; font-weight: 800; color: var(--text); line-height: 1.25; margin-bottom: 1rem; letter-spacing: -0.02em; }
  .hero-title span { background: linear-gradient(90deg, var(--accent), var(--accent2)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
  .hero-desc { font-size: 0.95rem; color: #a8a8c8; line-height: 1.75; font-weight: 400; }
  .panel { background: var(--surface); border: 1px solid var(--border); border-radius: 16px; padding: 1.75rem; }
  .panel-title { font-family: 'Bebas Neue', sans-serif; font-size: 0.75rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.12em; color: var(--muted); margin-bottom: 1.5rem; }
  .limit-banner { background: rgba(0,245,160,0.06); border: 1px solid rgba(0,245,160,0.15); border-radius: 10px; padding: 0.7rem 1rem; font-size: 0.8rem; color: var(--muted2); margin-bottom: 1.25rem; display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; }
  .limit-dots { display: flex; gap: 4px; }
  .limit-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--border); }
  .limit-dot.used { background: var(--accent); }
  .upgrade-link { color: var(--accent); font-weight: 500; cursor: pointer; background: none; border: none; padding: 0; font-family: 'DM Sans', sans-serif; font-size: 0.78rem; white-space: nowrap; }
  .field { margin-bottom: 1.25rem; }
  label { display: block; font-size: 0.8rem; font-weight: 500; color: var(--muted); margin-bottom: 0.5rem; letter-spacing: 0.03em; }
  input, textarea { width: 100%; background: var(--bg); border: 1px solid var(--border); border-radius: 10px; color: var(--text); font-family: 'DM Sans', sans-serif; font-size: 0.9rem; padding: 0.7rem 0.9rem; transition: border-color 0.2s; outline: none; resize: vertical; }
  input::placeholder, textarea::placeholder { color: #8890b0; }
  input:focus, textarea:focus { border-color: var(--accent); box-shadow: 0 0 0 3px rgba(0,245,160,0.08); }
  textarea { min-height: 80px; }
  .chip-group { display: flex; flex-wrap: wrap; gap: 0.5rem; }
  .chip { padding: 0.4rem 0.85rem; border-radius: 999px; border: 1px solid var(--border); background: var(--bg); color: var(--muted); font-size: 0.8rem; cursor: pointer; transition: all 0.15s; font-family: 'DM Sans', sans-serif; display: flex; align-items: center; gap: 0.35rem; }
  .chip:hover { border-color: var(--accent); color: var(--text); }
  .chip.active { background: rgba(0,245,160,0.12); border-color: var(--accent); color: var(--accent); font-weight: 500; }
  .counter { font-size: 0.75rem; color: var(--muted); text-align: right; margin-top: 0.3rem; }
  .generate-btn { width: 100%; padding: 0.9rem; border-radius: 12px; border: none; background: linear-gradient(135deg, var(--accent), var(--accent2)); color: #0a0a0f; font-family: 'Bebas Neue', sans-serif; font-size: 1.25rem; font-weight: 700; cursor: pointer; margin-top: 1.5rem; letter-spacing: 0.08em; transition: opacity 0.2s, transform 0.15s; }
  .generate-btn:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
  .generate-btn:disabled { opacity: 0.4; cursor: not-allowed; transform: none; }
  .results-area { display: flex; flex-direction: column; gap: 1.25rem; }
  .empty-state { background: var(--surface); border: 1px dashed var(--border); border-radius: 16px; padding: 4rem 2rem; text-align: center; color: var(--muted); }
  .empty-icon { font-size: 2.5rem; margin-bottom: 1rem; opacity: 0.5; }
  .empty-text { font-size: 0.9rem; font-weight: 400; line-height: 1.6; }
  .post-card { background: var(--surface); border: 1px solid var(--border); border-radius: 16px; overflow: hidden; animation: fadeUp 0.4s ease both; }
  @keyframes fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
  .post-header { display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem; border-bottom: 1px solid var(--border); }
  .post-platform { display: flex; align-items: center; gap: 0.5rem; font-family: 'Bebas Neue', sans-serif; font-weight: 700; font-size: 0.85rem; }
  .post-lang { font-size: 0.75rem; color: var(--muted); background: var(--bg); padding: 0.2rem 0.6rem; border-radius: 999px; border: 1px solid var(--border); }
  .post-body { padding: 1.25rem; font-size: 0.9rem; line-height: 1.7; white-space: pre-wrap; font-weight: 400; }
  .post-footer { display: flex; justify-content: flex-end; padding: 0.75rem 1.25rem; border-top: 1px solid var(--border); }
  .copy-btn { padding: 0.45rem 1rem; border-radius: 8px; border: 1px solid var(--border); background: transparent; color: var(--muted); font-size: 0.8rem; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: all 0.15s; }
  .copy-btn:hover { border-color: var(--accent); color: var(--accent); }
  .copy-btn.copied { border-color: var(--accent); color: var(--accent); background: rgba(0,245,160,0.08); }
  .loading-card { background: var(--surface); border: 1px solid var(--border); border-radius: 16px; padding: 2rem; text-align: center; color: var(--muted); font-size: 0.85rem; }
  .spinner { width: 28px; height: 28px; border: 2px solid var(--border); border-top-color: var(--accent); border-radius: 50%; animation: spin 0.8s linear infinite; margin: 0 auto 1rem; }
  @keyframes spin { to { transform: rotate(360deg); } }
  .error-msg { background: rgba(255,77,109,0.08); border: 1px solid rgba(255,77,109,0.3); border-radius: 10px; padding: 0.75rem 1rem; color: var(--danger); font-size: 0.85rem; margin-top: 0.75rem; }
  .modal-overlay { position: fixed; inset: 0; background: rgba(5,5,10,0.85); backdrop-filter: blur(8px); z-index: 200; display: flex; align-items: center; justify-content: center; padding: 1.5rem; animation: fadeIn 0.2s ease; }
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  .modal { background: #13131c; border: 1px solid var(--border); border-radius: 20px; padding: 2rem; width: 100%; max-width: 400px; position: relative; animation: slideUp 0.25s ease; }
  @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
  .modal-logo { font-family: 'Bebas Neue', sans-serif; font-size: 1.3rem; font-weight: 800; background: linear-gradient(90deg, var(--accent), var(--accent2)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; margin-bottom: 0.3rem; }
  .modal-subtitle { font-size: 0.82rem; color: var(--muted); margin-bottom: 1.75rem; line-height: 1.5; }
  .modal-tabs { display: flex; background: var(--bg); border-radius: 10px; padding: 3px; margin-bottom: 1.5rem; border: 1px solid var(--border); }
  .modal-tab { flex: 1; padding: 0.5rem; border: none; background: transparent; color: var(--muted); font-family: 'Bebas Neue', sans-serif; font-size: 0.82rem; font-weight: 700; border-radius: 8px; cursor: pointer; transition: all 0.15s; }
  .modal-tab.active { background: var(--surface); color: var(--text); border: 1px solid var(--border); }
  .modal-field { margin-bottom: 1rem; }
  .modal-btn { width: 100%; padding: 0.85rem; border-radius: 10px; border: none; background: linear-gradient(135deg, var(--accent), var(--accent2)); color: #0a0a0f; font-family: 'Bebas Neue', sans-serif; font-size: 0.9rem; font-weight: 700; cursor: pointer; margin-top: 0.5rem; transition: opacity 0.2s; }
  .modal-btn:hover { opacity: 0.88; }
  .modal-btn:disabled { opacity: 0.4; cursor: not-allowed; }
  .modal-close { position: absolute; top: 1rem; right: 1rem; background: transparent; border: none; color: var(--muted); font-size: 1.2rem; cursor: pointer; padding: 0.25rem 0.5rem; border-radius: 6px; line-height: 1; }
  .modal-close:hover { color: var(--text); }
  .modal-note { font-size: 0.72rem; color: var(--muted); text-align: center; margin-top: 1rem; line-height: 1.5; }
  .forgot-btn { background: none; border: none; color: var(--muted); font-size: 0.78rem; cursor: pointer; padding: 0; font-family: 'DM Sans', sans-serif; text-decoration: underline; display: block; margin-top: 0.4rem; }
  .forgot-btn:hover { color: var(--accent); }
  .pw-wrap { position: relative; }
  .pw-wrap input { padding-right: 2.5rem; }
  .pw-eye { position: absolute; right: 0.75rem; top: 50%; transform: translateY(-50%); background: none; border: none; cursor: pointer; color: var(--muted); padding: 0; line-height: 1; font-size: 1rem; }
  .pw-eye:hover { color: var(--text); }
  .reset-success { font-size: 0.82rem; color: var(--accent); text-align: center; margin-top: 0.75rem; }
  .modal-legal { font-size: 0.72rem; color: var(--muted); text-align: center; margin-top: 1rem; line-height: 1.6; }
  .modal-legal a { color: var(--accent); text-decoration: none; }
  .modal-legal a:hover { text-decoration: underline; }
  .app-footer { text-align: center; padding: 2rem 0 1rem; margin-top: 2rem; border-top: 1px solid var(--border); }
  .app-footer a { font-size: 0.8rem; color: var(--muted); text-decoration: none; margin: 0 0.75rem; }
  .app-footer a:hover { color: var(--accent); }
`;

export default function PostlifyAI() {
  const [form, setForm] = useState({
    industry: "", product: "", tone: "Professional",
    platforms: ["instagram", "linkedin"], langs: ["en"],
  });
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [copied, setCopied] = useState({});

  const [user, setUser] = useState(null);
  const [isPro, setIsPro] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [authTab, setAuthTab] = useState("signin");
  const [authForm, setAuthForm] = useState({ email: "", password: "" });
  const [authError, setAuthError] = useState("");
  const [authLoading, setAuthLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [usageCount, setUsageCount] = useState(() => {
    try {
      const s = JSON.parse(sessionStorage.getItem("pf_usage") || "{}");
      return s.date === new Date().toDateString() ? (s.count || 0) : 0;
    } catch { return 0; }
  });
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);


  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        setUser({ email: firebaseUser.email, displayName: firebaseUser.email.split("@")[0], uid: firebaseUser.uid });
        const headers = { "Content-Type": "application/json" };
        const token = await firebaseUser.getIdToken();
        headers["Authorization"] = `Bearer ${token}`;
        try {
          const res = await fetch(`${FUNCTIONS_BASE}/checkProStatus`, { method: "POST", headers });
          const data = await res.json();
          setIsPro(data.isPro || false);
        } catch (_) {
          setIsPro(false);
        }
      } else {
        setUser(null);
        setIsPro(false);
      }
    });
    return () => unsub();
  }, []);

  const isLimitReached = !user && usageCount >= FREE_LIMIT;
  const toggleArr = (key, val) =>
    setForm(f => ({ ...f, [key]: f[key].includes(val) ? f[key].filter(x => x !== val) : [...f[key], val] }));
  const canGenerate = form.industry.trim() && form.product.trim() && form.platforms.length && form.langs.length;

  const generate = async () => {
    if (isLimitReached) { setShowUpgradeModal(true); return; }
    setLoading(true); setError(""); setPosts([]);
    try {
      const headers = { "Content-Type": "application/json" };
      const token = await auth.currentUser?.getIdToken();
      if (token) headers["Authorization"] = `Bearer ${token}`;
      const res = await fetch(`${FUNCTIONS_BASE}/generatePosts`, {
        method: "POST",
        headers,
        body: JSON.stringify({ industry: form.industry, product: form.product, tone: form.tone, platforms: form.platforms, langs: form.langs }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Generation failed");
      setPosts(data.posts);
      if (!user) {
        const next = usageCount + 1;
        setUsageCount(next);
        try { sessionStorage.setItem("pf_usage", JSON.stringify({ date: new Date().toDateString(), count: next })); } catch (e) {}
        if (next >= FREE_LIMIT) setShowUpgradeModal(true);
      }
    } catch (e) {
      console.error("Function error:", e);
      setError(`Generation failed: ${e?.message || "Unknown error"}`);
    } finally { setLoading(false); }
  };

  const copyPost = (i, text) => {
    navigator.clipboard.writeText(text);
    setCopied(c => ({ ...c, [i]: true }));
    setTimeout(() => setCopied(c => ({ ...c, [i]: false })), 2000);
  };

  const handlePasswordReset = async () => {
    if (!authForm.email) { setAuthError("Enter your email address first."); return; }
    try {
      await sendPasswordResetEmail(auth, authForm.email);
      setResetSent(true);
      setAuthError("");
    } catch (e) {
      setAuthError(e.code === "auth/user-not-found" ? "No account found with that email." : "Failed to send reset email.");
    }
  };

  const handleAuth = async () => {
    setAuthLoading(true); setAuthError("");
    try {
      if (authTab === "signup") {
        await createUserWithEmailAndPassword(auth, authForm.email, authForm.password);
        setShowModal(false);
        setAuthForm({ email: "", password: "" });
        setTimeout(() => handleUpgrade(), 500);
      } else {
        await signInWithEmailAndPassword(auth, authForm.email, authForm.password);
        setShowModal(false);
        setAuthForm({ email: "", password: "" });
      }
    } catch (e) {
      const msg = e.code === "auth/email-already-in-use" ? "Email already in use." :
                  e.code === "auth/user-not-found" || e.code === "auth/wrong-password" || e.code === "auth/invalid-credential" ? "Invalid email or password." :
                  e.code === "auth/weak-password" ? "Password must be 6+ characters." :
                  e.code === "auth/invalid-email" ? "Enter a valid email." :
                  "Something went wrong. Please try again.";
      setAuthError(msg);
    } finally { setAuthLoading(false); }
  };

const handlePortal = async () => {
  try {
    const token = await auth.currentUser?.getIdToken();
    const res = await fetch(`${FUNCTIONS_BASE}/createPortalSession`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    });
    const data = await res.json();
    if (data.url) window.location.href = data.url;
  } catch (e) {
    console.error("Portal error:", e);
  }
};

const handleUpgrade = async () => {
  try {
    const userId = auth.currentUser?.uid;
    const res = await fetch(`${FUNCTIONS_BASE}/createCheckoutSession`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: user?.email || "", priceId: process.env.REACT_APP_STRIPE_PRICE_ID, userId }),
    });
    const data = await res.json();
    if (data.url) window.location.href = data.url;
  } catch (e) {
    console.error("Stripe error:", e);
  }
};

  const getPlatform = id => PLATFORMS.find(p => p.id === id);
  const getLangLabel = code => LANGS.find(l => l.code === code)?.label || code;

  return (
    <>
      <style>{STYLES}</style>
      <div className="app">
        <header>
          <div className="logo">Postlify AI</div>
          <div className="tagline">Social posts in seconds</div>
          <div className="header-right">
            <span className="price-label">Free trial · then</span>
            <span className="price-badge">€ 9.99 / month</span>
            {user ? (
              <>
                <div className="user-chip">
                  <div className="user-avatar">{user.displayName[0].toUpperCase()}</div>
                  {user.displayName}
                </div>
                {user.email === "info@westmanns.fi" && (
                  <Link to="/admin" style={{fontSize:"0.78rem",color:"var(--muted)",textDecoration:"none",padding:"0.38rem 0.8rem",border:"1px solid var(--border)",borderRadius:"8px"}}>Admin</Link>
                )}
                {isPro ? (
                  <button className="upgrade-link" style={{marginRight:"0.5rem"}} onClick={handlePortal}>Manage Subscription →</button>
                ) : (
                  <button className="upgrade-link" style={{marginRight:"0.5rem"}} onClick={handleUpgrade}>Upgrade to Pro →</button>
                )}
<button className="sign-out-btn" onClick={() => signOut(auth)}>Sign out</button>
              </>
            ) : (
              <button className="sign-in-btn" onClick={() => { setShowModal(true); setAuthTab("signin"); }}>Sign in</button>
            )}
          </div>
        </header>

        <div className="hero">
          <h1 className="hero-title">Turn your business into social media content — <span>instantly.</span></h1>
          <p className="hero-desc">Enter your industry and product, pick your platforms and languages, and get ready-to-post content for Instagram, LinkedIn, Facebook and TikTok in seconds. Copy, paste, and feel free to edit before posting.</p>
        </div>

        <div className="layout">
          <div className="panel">
            <div className="panel-title">Content Details</div>
            <div className="field">
              <label>Industry</label>
              <input placeholder="e.g. Car detailing, Fashion, Restaurant..."
                value={form.industry} onChange={e => setForm(f => ({...f, industry: e.target.value}))} />
            </div>
            <div className="field">
              <label>Product or Service</label>
              <textarea placeholder="Briefly describe what you sell or offer..."
                value={form.product} onChange={e => setForm(f => ({...f, product: e.target.value}))} />
              <div className="counter">{form.product.length} / 300</div>
            </div>
            <div className="field">
              <label>Tone</label>
              <div className="chip-group">
                {TONES.map(t => (
                  <button key={t} className={`chip${form.tone === t ? " active" : ""}`}
                    onClick={() => setForm(f => ({...f, tone: t}))}>{t}</button>
                ))}
              </div>
            </div>
            <div className="field">
              <label>Platforms</label>
              <div className="chip-group">
                {PLATFORMS.map(p => (
                  <button key={p.id} className={`chip${form.platforms.includes(p.id) ? " active" : ""}`}
                    onClick={() => toggleArr("platforms", p.id)}>{p.icon} {p.label}</button>
                ))}
              </div>
            </div>
            <div className="field">
              <label>Languages</label>
              <div className="chip-group">
                {LANGS.map(l => (
                  <button key={l.code} className={`chip${form.langs.includes(l.code) ? " active" : ""}`}
                    onClick={() => toggleArr("langs", l.code)}>{l.label}</button>
                ))}
              </div>
            </div>
            {error && <div className="error-msg">{error}</div>}
            <button className="generate-btn" onClick={generate} disabled={!canGenerate || loading}>
              {isLimitReached ? "🔒 Sign in to continue" : loading ? "Generating..." : "✦ Generate Posts"}
            </button>
          </div>

          <div className="results-area">
            {loading ? (
              <div className="loading-card"><div className="spinner" />Creating posts for your platforms...</div>
            ) : posts.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">✦</div>
                <div className="empty-text">Fill in the form and press<br /><strong>Generate Posts</strong></div>
              </div>
            ) : posts.map((post, i) => {
              const plat = getPlatform(post.platform);
              return (
                <div className="post-card" key={i} style={{animationDelay:`${i*0.08}s`}}>
                  <div className="post-header">
                    <div className="post-platform">{plat?.icon} {plat?.label}</div>
                    <span className="post-lang">{getLangLabel(post.lang)}</span>
                  </div>
                  <div className="post-body">{post.content}</div>
                  <div className="post-footer">
                    <button className={`copy-btn${copied[i] ? " copied" : ""}`} onClick={() => copyPost(i, post.content)}>
                      {copied[i] ? "✓ Copied!" : "Copy"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowModal(false)}>
          <div className="modal">
            <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
            <div className="modal-logo">Postlify AI</div>
            <div className="modal-subtitle">
              {authTab === "signin"
                ? "Sign in to unlock unlimited post generations."
                : "Create your account — first month free, then €9.99/month."}
            </div>
            <div className="modal-tabs">
              <button className={`modal-tab${authTab === "signin" ? " active" : ""}`}
                onClick={() => { setAuthTab("signin"); setAuthError(""); }}>Sign in</button>
              <button className={`modal-tab${authTab === "signup" ? " active" : ""}`}
                onClick={() => { setAuthTab("signup"); setAuthError(""); }}>Create account</button>
            </div>
            <div className="modal-field">
              <label>Email</label>
              <input type="email" placeholder="you@example.com"
                value={authForm.email} onChange={e => setAuthForm(f => ({...f, email: e.target.value}))} />
            </div>
            <div className="modal-field">
              <label>Password</label>
              <div className="pw-wrap">
                <input type={showPassword ? "text" : "password"} placeholder="••••••••"
                  value={authForm.password}
                  onChange={e => setAuthForm(f => ({...f, password: e.target.value}))}
                  onKeyDown={e => e.key === "Enter" && handleAuth()} />
                <button className="pw-eye" type="button" onClick={() => setShowPassword(s => !s)}>
                  {showPassword ? "🙈" : "👁"}
                </button>
              </div>
            </div>
            {authTab === "signin" && (
              <button className="forgot-btn" onClick={handlePasswordReset}>Forgot password?</button>
            )}
            {resetSent && <p className="reset-success">✓ Reset link sent — check your email.</p>}
            {authError && <div className="error-msg" style={{marginBottom:"0.5rem"}}>{authError}</div>}
            <button className="modal-btn" onClick={handleAuth} disabled={authLoading}>
              {authLoading ? "Please wait..." : authTab === "signin" ? "Sign in →" : "Create account →"}
            </button>
            {authTab === "signup" && (
              <p className="modal-note">€9.99/month after free trial. Cancel anytime. No credit card required to start.</p>
            )}
            <p className="modal-legal">
              By creating an account you agree to our{" "}
              <Link to="/terms" onClick={() => setShowModal(false)}>Terms of Service</Link>{" "}and{" "}
              <Link to="/privacy" onClick={() => setShowModal(false)}>Privacy Policy</Link>
            </p>
          </div>
        </div>
      )}

      {showUpgradeModal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowUpgradeModal(false)}>
          <div className="modal">
            <button className="modal-close" onClick={() => setShowUpgradeModal(false)}>✕</button>
            <div className="modal-logo">Postlify AI</div>
            <div className="modal-subtitle">
              You've used your free generation. Upgrade to Pro for unlimited posts.
            </div>
            <div style={{background:"var(--surface)",borderRadius:"12px",padding:"1.5rem",margin:"1.5rem 0",textAlign:"center"}}>
              <div style={{fontSize:"0.72rem",fontWeight:"600",textTransform:"uppercase",letterSpacing:"0.1em",color:"var(--muted)",marginBottom:"0.75rem"}}>Free</div>
              <div style={{fontSize:"1.8rem",fontFamily:"'Bebas Neue', sans-serif",background:"linear-gradient(90deg, var(--accent), var(--accent2))",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",marginBottom:"0.5rem"}}>1 / day</div>
              <div style={{fontSize:"0.8rem",color:"var(--muted)"}}>per 24 hours</div>
            </div>
            <div style={{background:"var(--bg)",borderRadius:"12px",padding:"1.5rem",margin:"1.5rem 0",border:"1px solid var(--accent)",textAlign:"center"}}>
              <div style={{fontSize:"0.72rem",fontWeight:"600",textTransform:"uppercase",letterSpacing:"0.1em",color:"var(--accent)",marginBottom:"0.75rem"}}>Pro</div>
              <div style={{fontSize:"1.8rem",fontFamily:"'Bebas Neue', sans-serif",color:"var(--text)",marginBottom:"0.25rem"}}>€9.99</div>
              <div style={{fontSize:"0.8rem",color:"var(--muted)",marginBottom:"1rem"}}>per month</div>
              <div style={{fontSize:"0.85rem",color:"var(--text)",fontWeight:"500"}}>100 generations/month</div>
            </div>
            <button className="modal-btn" onClick={handleUpgrade}>
              Upgrade to Pro →
            </button>
            <p style={{fontSize:"0.75rem",color:"var(--muted)",textAlign:"center",marginTop:"1rem",lineHeight:"1.5"}}>
              Cancel anytime. No credit card required for 14-day free trial.
            </p>
          </div>
        </div>
      )}

      <footer className="app-footer">
        <Link to="/terms">Terms of Service</Link>
        <Link to="/privacy">Privacy Policy</Link>
      </footer>
    </>
  );
}